import { render, staticRenderFns } from "./FormularioEdit.vue?vue&type=template&id=7fb50124&scoped=true&"
import script from "./FormularioEdit.vue?vue&type=script&lang=js&"
export * from "./FormularioEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormularioEdit.vue?vue&type=style&index=0&id=7fb50124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb50124",
  null
  
)

export default component.exports